var exports = {
  "Xb": "xaee3c4fa--158b6a--advice-list-article-author",
  "b_": "xaee3c4fa--158b6a--advice-list-article-author_avatar",
  "bH": "xaee3c4fa--158b6a--advice-list-article-author_avatar-small",
  "vV": "xaee3c4fa--158b6a--advice-list-article-author_avatar-outer",
  "YS": "xaee3c4fa--158b6a--advice-list-article-author_avatar-inner",
  "tM": "xaee3c4fa--158b6a--advice-list-article-author_avatar-img",
  "Lt": "xaee3c4fa--158b6a--advice-list-article-author_avatar-img-default",
  "Eg": "xaee3c4fa--158b6a--advice-list-article-author_info",
  "EX": "xaee3c4fa--158b6a--small",
  "_x": "xaee3c4fa--158b6a--advice-list-article-author_info-name",
  "Sd": "xaee3c4fa--158b6a--advice-list-article-author_info-descr",
  "ZJ": "xaee3c4fa--158b6a--advice-list-article-author_rating",
  "Nq": "xaee3c4fa--158b6a--user-trust",
  "Wg": "xaee3c4fa--158b6a--advice-list-article-author_info-empty-company",
  "bZ": "xaee3c4fa--158b6a--advice-list-article-author_rating-empty-company",
  "R9": "xaee3c4fa--158b6a--advice-list-article-author_info-mobile",
};

module.exports = exports;
